// src/components/filter.
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Progress } from 'reactstrap';

import {
    Col,
    Row,
} from "reactstrap"

//import components
import Breadcrumbs from 'components/_Common/Breadcrumb';
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

const PhaseSix = props => {
    //meta title
    document.title = `${props.t("Survey Phase Six")}  | ${props.t("Admin")}`;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(state?.prev_index || 0);
    const [questionSrNumber , setQuestionNumber] = useState(0)

    const { error, success, loading } = useSelector(state => ({
        loading: state.Survey.loading,
        error: state.Survey.error,
        success: state.Survey.success,
    }));
    const questions = state?.surveyData?.survey?.phase_six || [];

    const handleNext = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setQuestionNumber(questionSrNumber +1)
        } else {
            navigate('/complete-self-servey/phase-one', { state: { surveyData: state?.surveyData } });

        }
    };

    const handlePrevious = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
            setQuestionNumber(questionSrNumber -1)
        }
    };

    const completionPercentage = ((currentQuestionIndex + 1) / questions.length) * 100;


    useEffect(() => {

        if (Array.isArray(updateState?.surveyData?.survey?.phase_four)) {
            setQuestionNumber(updateState?.surveyData?.survey?.phase_four.length)
        }
    }, [])

    return (
        <React.Fragment>

            <div className="page-content">
                <div className="container-fluid">
                    <Row>
                        <div className="self-survey-main">
                            <div className="self-survey-inner">
                                <h3>{props.t('Lead Action SCHOR360 feedback tool')}</h3>
                                <div className="ques-progress">
                                    <Progress value={completionPercentage}>{completionPercentage.toFixed(0)}%</Progress>
                                </div>
                                {questions.length > 0 && currentQuestionIndex < questions.length && (
                                    <React.Fragment>
                                        <h5>{questionSrNumber + 1}. {questions[currentQuestionIndex].text}</h5>
                                        <input type="checkbox" />
                                        <div className="text-center space-survey-btn feed-back-button">
                                            {currentQuestionIndex > 0 && <button className="previous-ques" onClick={handlePrevious}>{props.t('Previous')}</button>}
                                            {currentQuestionIndex === 0 && <button className="previous-ques" onClick={() => navigate('/complete-self-servey/phase-three', { state: { surveyData: state?.surveyData } })}>{props.t('Previous')}</button>}

                                            {/* <button className="save-continue-ques">{props.t('Save to Continue later')}</button> */}
                                            <button className="next-ques" onClick={handleNext}>{props.t('Next')}</button>
                                        </div>
                                    </React.Fragment>
                                )}

                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

PhaseSix.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(PhaseSix);
